import React from 'react';
import { createRoot } from 'react-dom/client'; // Import createRoot from react-dom/client
import { BrowserRouter } from 'react-router-dom';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle';
import 'font-awesome/css/font-awesome.min.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './redux/store';
import { Provider } from 'react-redux';

// Use createRoot instead of ReactDOM.render
const container = document.getElementById('root');
const root = createRoot(container); // Create a root

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <App/>
    </Provider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Fix for footer shift when Bootstrap modal opens
// This prevents layout shift by maintaining scrollbar width space
(function() {
  // Calculate scrollbar width
  function getScrollbarWidth() {
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll';
    outer.style.msOverflowStyle = 'scrollbar';
    document.body.appendChild(outer);
    
    const inner = document.createElement('div');
    outer.appendChild(inner);
    
    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
    outer.parentNode.removeChild(outer);
    
    return scrollbarWidth;
  }
  
  // Set CSS variable with scrollbar width
  function setScrollbarWidth() {
    const scrollbarWidth = getScrollbarWidth();
    document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
  }
  
  // Initialize on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setScrollbarWidth);
  } else {
    setScrollbarWidth();
  }
  
  // Update on resize (in case scrollbar appears/disappears)
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setScrollbarWidth, 100);
  });
  
  // Handle Bootstrap modal events
  const modalElements = document.querySelectorAll('.modal');
  modalElements.forEach(function(modal) {
    modal.addEventListener('show.bs.modal', function() {
      setScrollbarWidth();
      const scrollbarWidth = getComputedStyle(document.documentElement).getPropertyValue('--scrollbar-width');
      document.body.style.paddingRight = scrollbarWidth || '0px';
    });
    
    modal.addEventListener('hidden.bs.modal', function() {
      document.body.style.paddingRight = '';
    });
  });
  
  // Also handle dynamically added modals
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 && node.classList && node.classList.contains('modal')) {
          node.addEventListener('show.bs.modal', function() {
            setScrollbarWidth();
            const scrollbarWidth = getComputedStyle(document.documentElement).getPropertyValue('--scrollbar-width');
            document.body.style.paddingRight = scrollbarWidth || '0px';
          });
          
          node.addEventListener('hidden.bs.modal', function() {
            document.body.style.paddingRight = '';
          });
        }
      });
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();